module.exports = __webpack_public_path__ + "static/media/tahsiLite - buton-badge.f3239a8a.svg";